import { t } from 'i18next';
import { OntologyItem } from '../../administration.config';

export interface Item {
  id: string;
  name: string;
  createdById: string | undefined;
  // log: string | undefined;
  // comment: string | undefined;
  description: string | undefined;
  creationDate: string | undefined;
  roadToCurrentState: string | undefined;
  keyPersonSet: string | undefined;
  geoDataSet: string | undefined;
  geoSituation: string | undefined;
  agentData: string | undefined;
}

export interface SettingPropsType {
  activeKey: string;
  defaultKey: string;
}
export const deleteConfirmTitles = () => ({
  title: t('general.deleteConfirmTitle'),
  okText: t('general.no'),
  cancelText: t('general.yes'),
});

export const collapse = {
  marginLeft: -15,
} as React.CSSProperties;
